/**
 * Filtered views sent over the wire. These are the ONLY shapes the client sees;
 * they are designed so the *type itself* cannot express a live secret.
 *
 * - PublicView is castable to a TV — no living player's role is ever present.
 * - PrivateView is per-socket — carries only what that one recipient may see.
 *
 * The server derives these from secret engine state via engine.toPublicView /
 * engine.toPrivateView (the only filtering functions in the codebase).
 */
/** A special vote value meaning the voter chose not to lynch anyone. */
export const ABSTAIN = 'ABSTAIN';
//# sourceMappingURL=state.js.map